/* jshint ignore:start */

var CoursesStaticManager = (function($) {
    // console.log("llamada a config idioma");
    var instance;

    function init() {

        var _$showBtn,
            _$hideBtn,
            _$otherCourses;


        // function toogleOtherCourses() {
        //     // console.log('más cursos click');
        //     _$otherCourses.toogle();
        // }


        return {
            initCommon: function() {
                _$hideBtn = $('.js-courses-static-hide');
                _$otherCourses = $('.js-courses-static-other');

                _$showBtn.on('click', function (e) {
                    e.preventDefault();

                    _$otherCourses.slideDown();
                    _$showBtn.hide();
                    _$hideBtn.show();
                });

                _$hideBtn.on('click', function (e) {
                    e.preventDefault();

                    _$otherCourses.slideUp();
                    _$hideBtn.hide();
                    _$showBtn.show();
                });
            },


            init: function() {
                _$showBtn = $('.js-courses-static-show');

                if (_$showBtn.length) {
                    // console.log('más cursos inittttt');
                    this.initCommon();
                }
            }
        };
    }


    return {

        getInstance: function(){

            if (!instance){
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */

